var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginGrassTopRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 109,
    viewBox: "0 0 270 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.8575 106.888C162.627 99.0085 235.474 115.756 259.566 88.0843C263.138 83.9925 266.102 79.0253 268.591 73.1445C273.436 61.7254 264.715 54.8169 258.597 49.6022C240.243 33.9391 201.71 36.5845 185.541 56.9484C179.708 56.9484 194.566 13.499 153.867 18.0667C122.479 21.5875 123.638 48.5364 123.638 48.3651C123.638 32.5117 126.906 3.298 98.7287 0.176795C71.1783 -2.86828 57.821 34.2056 57.821 51.0106C57.821 88.9408 56.415 44.73 25.3875 52.0001C-3.68296 58.8325 -33.3234 121.142 92.8575 106.888Z",
    fill: "#CDE8F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginGrassTopRight);
export default __webpack_public_path__ + "static/media/login-grass-top-right.d79764005d1087fd22f0e8bbc3fae634.svg";
export { ForwardRef as ReactComponent };